
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"64","height":"64","fill":"#3D2562","rx":"8.258"}}),_c('path',{attrs:{"fill":"#7E5FDD","d":"M32 19.097L21.161 24.26l.516 8.258L32 44.387l7.742-4.644c1.376-3.097 2.064-4.818 2.064-5.162 0-.344.172-1.72.517-4.129.344-2.064.344-3.269 0-3.613-.345-.344-3.785-2.924-10.323-7.742z"}}),_c('path',{attrs:{"fill":"#FFF","fill-rule":"nonzero","d":"M30.932 17.777l-9.233 4.12a2.661 2.661 0 00-1.57 2.426v6.228c0 7.354 5.065 14.231 11.871 15.9 6.806-1.669 11.871-8.546 11.871-15.9v-6.228a2.661 2.661 0 00-1.57-2.425l-9.233-4.121a2.611 2.611 0 00-2.136 0zM32 31.863h9.233c-.7 5.459-4.326 10.322-9.233 11.846V31.876h-9.233v-7.553L32 20.202v11.66z"}})])])
          )
        }
      }
    